import Automations from "./Automations.vue";
export default Automations;
